const config = {
    apiUrl: "https://account.agridential.vn/api/v1", // Cấu hình trực tiếp API URL
  };
  
  export default config;
  
